import { Component } from '@angular/core';
import { ManagementComponent } from '@src/base-components/management/management.component'

@Component({
    selector: 'app-page-mananagement-bellross',
    templateUrl: './management-bellross.component.html'
})
export class ManagementBellRossComponent extends ManagementComponent {
}
